import {assert} from 'assert-ts';
import {useAppSelector} from 'store/hooks';
import {selectMetadataEditSavedMetadataManifestationById} from '../metadataEditSlice';
import {useCreateSelectorById} from './useCreateSelectorById';
import type {ManifestationV4} from '../types';

export const useSavedManifestation = (
  manifestationId: string,
): ManifestationV4 => {
  const manifestation = useAppSelector(
    useCreateSelectorById(
      manifestationId,
      selectMetadataEditSavedMetadataManifestationById,
    ),
  );

  if (!manifestation) {
    assert(false, 'useSavedManifestation: unknown manifestationId', {
      manifestationId,
    });
  }

  return manifestation;
};
